import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

/**
 * @deprecated Use `CustomTooltip` with `color="normal"` (same raised surface, but follows the theme tokens and
 * dark mode; pass `arrow` explicitly — HTMLTooltip defaults it on). Hardcoded white surface / black text here
 * doesn't adapt to dark mode.
 */
export const HTMLTooltip = styled(({
  className,
  arrow = true,
  ...props
}) => <Tooltip {...props} classes={{
  popper: className
}} arrow={arrow} />)(({
  theme
}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1]
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'whitesmoke'
  }
}));